import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {BillingPeriod} from '../domain/billing-period';
import {map} from 'rxjs/operators';
import {ChargesWithBillingPeriod} from '../domain/charges-with-billing-period';

@Injectable({
  providedIn: 'root'
})
export class BillCalcService extends BaseService {
  private readonly rootPath = '/billing';

  constructor(private http: HttpClient) {
    super(http, '');
  }

  // tslint:disable-next-line:max-line-length
  runBillCalc(startDate: string, endDate: string, deliveryCode: string, supplyCode: string, file: any): Observable<ChargesWithBillingPeriod> {
    let url = `${this.rootPath}/run?startDate=${startDate}&stopDate=${endDate}&deliveryCode=${deliveryCode}&supplyCode=`;
    if (supplyCode) {
      url += supplyCode;
    }
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<ChargesWithBillingPeriod>(url, formData).pipe(map(charges => {
      return {...charges, startDate, endDate};
    }));
  }

  getBillingPeriods(file: any): Observable<Array<BillingPeriod>> {
    const url = `${this.rootPath}/periods`;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<Array<BillingPeriod>>(url, formData);
  }
}
